import { observable, action } from 'mobx';

import { emit, events } from '@estee/elc-service-bus';

import ICartSidebar, {
    ICartOverlayVisibilityProps
} from '~domain/entities/CartSidebar/ICartSidebar';
import { isVulcan } from '~utils/isVulcan';

export default class CartSidebar implements ICartSidebar {
    @observable isVisible: ICartSidebar['isVisible'] = false;
    @observable isLoading: ICartSidebar['isLoading'] = false;
    @observable displayItemAddedText: ICartSidebar['displayItemAddedText'] = false;
    @observable displayCartOffersComponent: ICartSidebar['displayCartOffersComponent'] = true;
    @observable activeTab: ICartSidebar['activeTab'] = 0;
    @observable offerCount: ICartSidebar['offerCount'] = 0;
    @observable autoClose: ICartSidebar['autoClose'] = false;
    @observable displayMiniOverlay: ICartSidebar['displayMiniOverlay'] = false;

    @action
    public setLoading = (newState: boolean) => {
        this.isLoading = newState;
    };

    @action
    public setDisplayItemAddedText = (newState: boolean) => {
        this.displayItemAddedText = newState;
    };

    @action
    public setVisibility = (params: ICartOverlayVisibilityProps): void => {
        const { newState = !!params, isUserEvent = false, autoClose = false } = params || {};
        const isStateUpdated = this.isVisible !== newState;

        if (isStateUpdated) {
            const eventToUse = newState ? events.CART_OVERLAY_OPENED : events.CART_OVERLAY_CLOSED;
            const eventParams = { nonInteraction: !isUserEvent, event_action : newState ? 'view_cart' : 'close' };

            if (isVulcan()) {
                window.dispatchEvent(new CustomEvent(eventToUse, {detail: eventParams}));
            } else {
                emit(eventToUse, eventParams);
            }
        }

        this.autoClose = autoClose;
        this.isVisible = newState;
    };

    @action
    public setActiveTab = (newState: number): void => {
        this.activeTab = newState;
    };

    @action
    public setOfferCount = (newState: number): void => {
        this.offerCount = newState;
    };

    @action
    public setDisplayCartOffersComponent = (newState: boolean): void => {
        this.displayCartOffersComponent = newState;
    };

    @action
    public setDisplayMiniOverlay = (newState: boolean): void => {
        this.displayMiniOverlay = newState;
    };
}
